import {
  Breadcrumb,
  ConfigProvider,
  DatePicker,
  Input,
  Pagination,
  Select,
  Tooltip,
  Typography
} from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../../../Layout';
import './style.scss';

import { SearchOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { PaginationProps } from 'antd/lib';
import viVN from 'antd/locale/vi_VN';
import { IListHistoryLog } from '../../../api/Customer_V2/customerApi_V2';
import { getListSystemLog } from '../../../api/groupPermission/groupPermissionApi';
import { NodataTable } from '../../../components/NoDataTable';
import { NO_DATA } from '../../../env';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useToast from '../../../hook/useToast';
import { formatNumber } from '../../../services/mixin';
import { CustomLoadingOverlayTable, dataPagination, formatDateToDMY, genderLinkForLogV4 } from '../../../until';
import { IPagination } from '../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';

interface IActivityLog {
  id: number;
  name: string;
  email: string;
  time: string;
  action: string;
}

const { RangePicker } = DatePicker;
const { Title } = Typography;
const { Option } = Select;


interface IFilter {
  search?: string;
  dateStart: string;
  dateEnd: string;
}

const initFilter: IFilter = {
  search: undefined,
  dateStart: "" as string,
  dateEnd: "" as string,
};

const ActivityLog: React.FC = () => {
  const pushLoading = useLoading()
  const pushToast = useToast();

  const [filters, setFilters] = useState<IFilter>(initFilter)
  const [pagination, setPagination] = useState<IPagination>({ current: 1, pageSize: 10, total: 0 })

  const [listSystemLog, setListSystemLog] = useState<IListHistoryLog[]>([])
  const [loadingTable, setLoadingTable] = useState(false)

  const columnDefs: ColDef<IListHistoryLog>[] = useMemo(() => [
    {
      headerName: 'Họ và tên nhân viên',
      width: 220,
      cellRenderer: (params: { data?: IListHistoryLog }) => {
        return params.data?.fullname ?? NO_DATA;
      },
    },
    {
      headerName: 'Email',
      width: 280,
      cellStyle: {
        color: '#666666',
        paddingLeft: '16px',
        paddingRight: '16px',
      },
      cellRenderer: (params: { data?: IListHistoryLog }) => {
        return params.data?.email ?? NO_DATA;
      },
    },
    {
      headerName: 'Thời gian',
      width: 180,
      cellStyle: {
        color: '#666666',
        paddingLeft: '16px',
        paddingRight: '16px',
      },
      cellRenderer: (params: { data?: IListHistoryLog }) => {
        const [date, time] = params.data?.createdAt.split(" ") ?? []
        const dateTmp = formatDateToDMY(date ?? "")
        return dateTmp ? (time + " " + dateTmp) : NO_DATA;
      },

    },
    {
      headerName: 'Hành động',
      flex: 1,
      minWidth: 350,
      cellStyle: {
        color: '#333333',
        paddingLeft: '16px',
        paddingRight: '16px',
      },
      cellRenderer: (params: { data?: IListHistoryLog }) => {
        return <Tooltip
          placement="right"
          color="white"
          title={
            <div className="custom-page-css flex flex-col gap-1" style={{ color: "#000" }}>
              {params?.data?.HistorySummaries?.map((item, i) => (
                <div key={i}>{item.description}</div>
              ))}
            </div>
          }
        >
          <span className="custom-page-css " >
            {genderLinkForLogV4(params?.data?.HistorySummaries[0])}
          </span>
        </Tooltip>
      },
    },
  ], [listSystemLog]);


  const gListSystemLog = useDebounce(async (
    pageNumber: number = 1, limit: number = 10,
  ) => {
    setLoadingTable(true)
    const { dateEnd, dateStart, search } = filters
    const dateEndTmp = dateEnd.length > 2 ? dateEnd : undefined
    const dateStartTmp = dateStart.length > 2 ? dateStart : undefined

    const result = await getListSystemLog(
      limit, pageNumber, search, dateStartTmp,
      dateEndTmp
    );
    if (result?.status) {
      setListSystemLog(result.data)

      setPagination({ current: pageNumber, total: result.total, pageSize: limit })
    } else {
      pushToast(result?.message, 'error', 2000)
    }
    setLoadingTable(false)
  }, 1000)

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    gListSystemLog(pageNumber, pageSize)
  }

  useEffect(() => {
    gListSystemLog()
  }, [filters])
  return (

    <div className="notification-templates-management">
      <Layout>
        <Breadcrumb
          items={[
            {
              title: 'THACO AUTO CRM',
            },
            {
              title: <a href="/">Quản trị phần mềm</a>,
            },
            {
              title: 'Log hoạt động',
            },
          ]}
        />
        <div className='title-page title-sub'>
          Log hoạt động
        </div>
        {/* <div className="custom-page-css flex items-center justify-between">
          <span className='custom-page-css text-base font-medium'>Thời gian phiên làm việc</span>
          <div className="custom-page-css flex items-center gap-2">
            <span className='custom-page-css text-base font-regular'>Đăng xuất hệ thống sau</span>
            <div className="custom-page-css flex flex-1 overflow-hidden">

              <Select
                className='custom-page-css flex  w-full'
                placeholder=""
                
                options={dataTimeLogOut}
              />
            </div>
            <span className='custom-page-css text-base font-regular'>phút</span>
          </div>
        </div> */}
        {/* <div className="custom-page-css flex gap-3 items-center py-4">
          <div className="custom-page-css flex flex-1 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
            <Input
              placeholder="Tìm kiếm theo hành động"
              className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
              value={filters.search}
              onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            />
          </div>

          <div className="t-ctrl-date-picker-block mw-256">
            <RangePicker
              popupClassName=" t-ctrl-date-picker "
              placeholder={["Từ ngày", "Đến ngày"]}
              format="DD/MM/YYYY"
              allowClear
              value={
                filters.dateStart && filters.dateEnd ?
                  [
                    dayjs(filters.dateStart),
                    dayjs(filters.dateEnd),
                  ] :
                  null
              }
              onCalendarChange={(dates) => {
                setFilters({
                  ...filters,
                  dateStart: dates?.[0]?.format("YYYY/MM/DD") ?? "",
                  dateEnd: dates?.[1]?.format("YYYY/MM/DD") ?? "",
                },
                );
              }}
            />
          </div>

        </div>
        <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
          <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
            <AgGridReact
              className="my-auto-height-grid" getRowStyle={(params: any) => ({
                backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
              rowData={listSystemLog}
              rowHeight={55}
              columnDefs={columnDefs}
              overlayNoRowsTemplate={NodataTable}
              suppressDragLeaveHidesColumns={true}
            />

          </div>
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination
                showSizeChanger
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                className='rs-pagination'
                onChange={onPaginationChange}
              />
            </div>
          </ConfigProvider>
        </div> */}


        <div className="custom-page-css flex flex-col gap-5">
          <div className="custom-page-css w-full flex items-center gap-4">

            {/* <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
                    <Input
                        placeholder="Tìm kiếm"
                        className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
                        allowClear
                        value={dataFilterList.search}
                        onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
                    />
                    <div className=" border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div> */}

            <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
              <Input
                placeholder="Tìm kiếm theo hành động"
                className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
                value={filters.search}
                onChange={(e) => setFilters({ ...filters, search: e.target.value })}
              />
              <div className="border-l-F2F4F7 h-full d-flex align-center">
                <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
              </div>
            </div>

            <ConfigProvider locale={viVN}>
              <RangePicker
                className="custom-input-date py-6px"
                // open={true}
                placeholder={["Bắt đầu", "Kết thúc"]}
                format="DD/MM/YYYY"
                allowClear
                value={
                  filters.dateStart && filters.dateEnd ?
                    [
                      dayjs(filters.dateStart),
                      dayjs(filters.dateEnd),
                    ] :
                    null
                }
                onCalendarChange={(dates) => {
                  setFilters({
                    ...filters,
                    dateStart: dates?.[0]?.format("YYYY/MM/DD") ?? "",
                    dateEnd: dates?.[1]?.format("YYYY/MM/DD") ?? "",
                  },
                  );
                }}
              />
            </ConfigProvider>
          </div>


          {/* <div className="custom-page-css py-3">
            <Timeline
              className="custom-timeline overflow-hidden pt-5"
              mode="left"
              style={{ "--timeline-item-left-width": "80px" } as React.CSSProperties}
              items={listSystemLog.map((item, idx) => ({
                key: idx,
                dot: (
                  <Avatar
                    size={42}
                    src={
                      <img
                        src={URL_AVATAR + item.img}
                        onError={(e) => {
                          e.currentTarget.src = avatarDefault;
                        }}
                      />
                    }
                  />
                ),
                label: (
                  <div style={{ width: 80, textAlign: "right" }} className="custom-page-css text-475467 text-base font-regular">
                    <div>{item.createdAt.split(" ")[0]}</div>
                    <div>{item.createdAt.split(" ")[1]}</div>
                  </div>
                ),
                children: (
                  <>
                    <div className="custom-page-css font-medium text-sm">
                      {item.fullname} (<span className="" style={{ color: "#1890FF" }}>{item.code}</span>)
                    </div>
                    <div className="custom-page-css text-xs text-667085 font-regular pb-1">{item.email}</div>
                    <ul className="custom-page-css bg-F8F8F8 mt-2 list-disc-none text-sm px-2 py-2 rounded ">
                      {item.HistorySummaries.map((item, i) => (
                        <li key={i} className="custom-page-css flex items-center gap-1">
                          <div>{genderLinkForLogV2(item)}</div>
                          <Tooltip
                            className={`${item.historyLogDetails.length ? "" : "d-none"}`}
                            placement="right"
                            color="white"
                            title={
                              <div className="Tooltip-custom-css">
                                {item.historyLogDetails.map((itemC, j) => (
                                  <div key={j} className="custom-page-css flex items-center gap-7 justify-between ">
                                    <span className="custom-page-css text-sm font-regular text-667085">
                                      {"customer" in itemC
                                        ? itemC.customer?.username
                                        : itemC.admin?.fullname}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            }
                          >
                            <div className="custom-page-css flex items-center gap-1 bg-E6F7FF rounded-lg px-2 cursor-pointer">
                              <div className="font-light color-bage">{item.historyLogDetails.length}</div>
                              <img src={info_cicrle} alt="Avatar" />
                            </div>
                          </Tooltip>
                        </li>
                      ))}
                    </ul>
                  </>
                ),
              }))}
            />
            <ConfigProvider locale={viVN}>
              <div className="pagination-block">
                <Pagination
                  showSizeChanger
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  itemRender={(page, type, originalElement) => {
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    return originalElement;
                  }}
                  showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                  className='rs-pagination'
                  onChange={onPaginationChange}
                />
              </div>
            </ConfigProvider>
          </div> */}
          <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
            <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
              <AgGridReact
                className="my-auto-height-grid" getRowStyle={(params: any) => ({
                  backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                })}
                rowData={listSystemLog}
                rowHeight={55}
                columnDefs={columnDefs}
                overlayNoRowsTemplate={NodataTable}
                suppressDragLeaveHidesColumns={true}

                loading={loadingTable}

                loadingOverlayComponent={CustomLoadingOverlayTable}
              />

            </div>
            <ConfigProvider locale={viVN}>
              <div className="pagination-block">
                <Pagination
                  showSizeChanger
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  itemRender={(page, type, originalElement) => {
                    // Chỉ custom khi là nút số trang
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    // prev / next / jump-prev / jump-next giữ nguyên
                    return originalElement;
                  }}
                  showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                  className='rs-pagination'
                  onChange={onPaginationChange}
                />
              </div>
            </ConfigProvider>
          </div>

        </div>





      </Layout>
    </div>
  );
};

export default ActivityLog;